import * as React from 'react';

import { EMainMenuBadge, ERefsLeftMenu } from '@enums';

import { updateLinkParams } from '@utils';

import { IMainMenuApp } from '@stores';

import { MainMenuBadge, MainMenuItem, MainMenuSet } from '@components';

interface IMainMenuAppSetProps {
	appsArray: IMainMenuApp[];
	title: string;
	isMyCreated?: boolean;
	customRef?: string;
}

export const MainMenuAppsSet: React.FunctionComponent<IMainMenuAppSetProps> =
	({
		appsArray = [],
		title,
		customRef,
		isMyCreated,
	}: IMainMenuAppSetProps) => {
		if (!appsArray?.length) {
			return null;
		}

		return (
			<MainMenuSet title={title}>
				{
					appsArray.map((app: IMainMenuApp) => {
						const badge = app.badge ? <MainMenuBadge type={app.badge}/> : null;
						let ref: ERefsLeftMenu | string = ERefsLeftMenu.GAMES;

						if (customRef) {
							ref = customRef;
						} else {
							switch (app.badge) {
								case EMainMenuBadge.APP_HIT:
									ref = ERefsLeftMenu.GAMES_HIT;
							}
						}

						return <MainMenuItem
							key={app.id}
							title={app.title}
							link={updateLinkParams(app.url, { ref })}
							image={app.icon}
							badge={badge}
							isOuterLink={isMyCreated}
						/>;
					})
				}
			</MainMenuSet>
		);
	};
